import { useDeferredValue } from "react";
import { useQuery } from "@tanstack/react-query";

import { autocompleteService } from "@/features/shop/services/autocomplete.service";

const MINIMUM_CHARACTERS = 2;
const STALE_TIME_MS = 30_000;

type AutocompleteSearchOptions = { catalogueId?: number };

export const useAutocompleteSearch = (query: string, options?: AutocompleteSearchOptions) => {
  const deferredQuery = useDeferredValue(query);
  const trimmedQuery = deferredQuery.trim();
  const isQueryValid = trimmedQuery.length >= MINIMUM_CHARACTERS;

  const { data, isLoading, isError } = useQuery({
    queryKey: ["shop-autocomplete", trimmedQuery, options?.catalogueId],
    queryFn: () => autocompleteService.search(trimmedQuery, { catalogueId: options?.catalogueId }),
    enabled: isQueryValid,
    staleTime: STALE_TIME_MS,
    refetchOnWindowFocus: false,
  });

  return {
    results: data?.results ?? [],
    suggestions: data?.suggestions ?? [],
    isLoading: isQueryValid && isLoading,
    isError,
    isQueryValid,
  };
};
